import { render, staticRenderFns } from "./UsuarioComponent.vue?vue&type=template&id=10b97396&scoped=true"
import script from "./UsuarioComponent.vue?vue&type=script&lang=js"
export * from "./UsuarioComponent.vue?vue&type=script&lang=js"
import style0 from "./UsuarioComponent.vue?vue&type=style&index=0&id=10b97396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b97396",
  null
  
)

export default component.exports